import { format } from 'date-fns'

import { revivalApi } from 'redux/services/revival'

import { AppLoader } from 'components/AppLoader'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'

import {
  REVIVAL_PRODUCT_NAME_TEXT,
  REVIVAL_STATUS_TEXT,
  REVIVAL_TYPE_REQUEST_TEXT,
} from 'constants/revival'
import { RevivalObject } from 'models/revival'

import { DocumentsList, LabledInfo } from 'shared/ui'

import styles from './Details.module.scss'

interface DetailsProps {
  id: RevivalObject['id']
  onClose: () => void
}

export const Details = ({ id, onClose }: DetailsProps) => {
  const { data, isLoading, isSuccess, error } =
    revivalApi.useGetRevivalByIdQuery(id)

  function renderValue(label: string, key: keyof RevivalObject) {
    if (data?.[key]) {
      return <LabledInfo label={label}>{data?.[key]}</LabledInfo>
    }
    return null
  }

  if (isLoading) return <AppLoader />

  if (isSuccess) {
    return (
      <>
        <AppModalHeader onClose={onClose} title={data.name} />
        <div className={styles.container}>
          {renderValue('ID', 'id')}
          {renderValue('Наименование', 'name')}
          {renderValue('Номер телефона', 'phone_number')}
          <LabledInfo label="Тип заявки">
            {REVIVAL_TYPE_REQUEST_TEXT[data.type_request]}
          </LabledInfo>
          <LabledInfo label="Продукт">
            {REVIVAL_PRODUCT_NAME_TEXT[data.product_name]}
          </LabledInfo>
          <LabledInfo label="Дата создания">
            {data.created_at
              ? format(new Date(data.created_at), 'dd.MM.yyyy HH:mm')
              : '-'}
          </LabledInfo>
          <LabledInfo label="Дата начала">
            {data.start_date
              ? format(new Date(data.start_date), 'dd.MM.yyyy HH:mm')
              : '-'}
          </LabledInfo>
          <LabledInfo label="Дата окончания">
            {data.end_date
              ? format(new Date(data.end_date), 'dd.MM.yyyy HH:mm')
              : '-'}
          </LabledInfo>
          <LabledInfo label="Прогресс">{data.progress}</LabledInfo>
          <LabledInfo label="Статус">
            {REVIVAL_STATUS_TEXT[data.status]}
          </LabledInfo>

          {renderValue('Комментарий', 'comment')}

          <LabledInfo label="Обучение">
            {data.training_completed ? 'Да' : 'Нет'}
          </LabledInfo>
          <LabledInfo label="Промо материалы">
            {data.promo_materials_left ? 'Да' : 'Нет'}
          </LabledInfo>
          {data.consultant ? (
            <div className={styles.item}>
              <div className={styles.itemName}>Консультант</div>
              <div className={styles.itemText}>
                <strong>ФИО:</strong>
                <span>{data.consultant.full_name}</span>
              </div>
              <div className={styles.itemText}>
                <strong>Телефон:</strong>
                <span>{data.consultant.phone}</span>
              </div>
              <div className={styles.itemText}>
                <strong>Филиал:</strong>
                <span>
                  {data.consultant.main_branch || data.consultant.branches}
                </span>
              </div>
              <div className={styles.itemText}>
                <strong>ИНН:</strong>
                <span>{data.consultant.inn}</span>
              </div>
            </div>
          ) : null}

          <DocumentsList list={data.other_documents} />
        </div>
      </>
    )
  }

  return <code>{JSON.stringify(error)}</code>
}
